module.exports = __webpack_public_path__ + "static/img/app_icon.6e1150d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/app_icon.png
// module id = 452
// module chunks = 8